/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DimensionContributionLine } from './DimensionContributionLine';
import {
    DimensionContributionLineFromJSON,
    DimensionContributionLineFromJSONTyped,
    DimensionContributionLineToJSON,
    DimensionContributionLineToJSONTyped,
} from './DimensionContributionLine';

/**
 * 
 * @export
 * @interface InitiativeMaturityCompositeDto
 */
export interface InitiativeMaturityCompositeDto {
    /**
     * 
     * @type {string}
     * @memberof InitiativeMaturityCompositeDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeMaturityCompositeDto
     */
    capabilityDomain?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    targetMaturity?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    compositeBaseline?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    compositeCurrent?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    compositeTarget?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    compositeDesigned?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    compositeOperational?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    compositeValidated?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    operationalGap?: number;
    /**
     * 
     * @type {string}
     * @memberof InitiativeMaturityCompositeDto
     */
    operationalStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    weightSum?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    dimensionsTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    dimensionsScored?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMaturityCompositeDto
     */
    dimensionsValidated?: number;
    /**
     * 
     * @type {Array<DimensionContributionLine>}
     * @memberof InitiativeMaturityCompositeDto
     */
    contributions?: Array<DimensionContributionLine>;
}

/**
 * Check if a given object implements the InitiativeMaturityCompositeDto interface.
 */
export function instanceOfInitiativeMaturityCompositeDto(value: object): value is InitiativeMaturityCompositeDto {
    return true;
}

export function InitiativeMaturityCompositeDtoFromJSON(json: any): InitiativeMaturityCompositeDto {
    return InitiativeMaturityCompositeDtoFromJSONTyped(json, false);
}

export function InitiativeMaturityCompositeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeMaturityCompositeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'capabilityDomain': json['capabilityDomain'] == null ? undefined : json['capabilityDomain'],
        'targetMaturity': json['targetMaturity'] == null ? undefined : json['targetMaturity'],
        'compositeBaseline': json['compositeBaseline'] == null ? undefined : json['compositeBaseline'],
        'compositeCurrent': json['compositeCurrent'] == null ? undefined : json['compositeCurrent'],
        'compositeTarget': json['compositeTarget'] == null ? undefined : json['compositeTarget'],
        'compositeDesigned': json['compositeDesigned'] == null ? undefined : json['compositeDesigned'],
        'compositeOperational': json['compositeOperational'] == null ? undefined : json['compositeOperational'],
        'compositeValidated': json['compositeValidated'] == null ? undefined : json['compositeValidated'],
        'operationalGap': json['operationalGap'] == null ? undefined : json['operationalGap'],
        'operationalStatus': json['operationalStatus'] == null ? undefined : json['operationalStatus'],
        'weightSum': json['weightSum'] == null ? undefined : json['weightSum'],
        'dimensionsTotal': json['dimensionsTotal'] == null ? undefined : json['dimensionsTotal'],
        'dimensionsScored': json['dimensionsScored'] == null ? undefined : json['dimensionsScored'],
        'dimensionsValidated': json['dimensionsValidated'] == null ? undefined : json['dimensionsValidated'],
        'contributions': json['contributions'] == null ? undefined : ((json['contributions'] as Array<any>).map(DimensionContributionLineFromJSON)),
    };
}

export function InitiativeMaturityCompositeDtoToJSON(json: any): InitiativeMaturityCompositeDto {
    return InitiativeMaturityCompositeDtoToJSONTyped(json, false);
}

export function InitiativeMaturityCompositeDtoToJSONTyped(value?: InitiativeMaturityCompositeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'capabilityDomain': value['capabilityDomain'],
        'targetMaturity': value['targetMaturity'],
        'compositeBaseline': value['compositeBaseline'],
        'compositeCurrent': value['compositeCurrent'],
        'compositeTarget': value['compositeTarget'],
        'compositeDesigned': value['compositeDesigned'],
        'compositeOperational': value['compositeOperational'],
        'compositeValidated': value['compositeValidated'],
        'operationalGap': value['operationalGap'],
        'operationalStatus': value['operationalStatus'],
        'weightSum': value['weightSum'],
        'dimensionsTotal': value['dimensionsTotal'],
        'dimensionsScored': value['dimensionsScored'],
        'dimensionsValidated': value['dimensionsValidated'],
        'contributions': value['contributions'] == null ? undefined : ((value['contributions'] as Array<any>).map(DimensionContributionLineToJSON)),
    };
}

